<template>
    <div class="exchangeCoupon">
        <ul v-for="(coupon,index) in couponsInfo" :key="index">
            <li>
                <p>
                    <span>{{coupon.money2}}</span>
                    <span>RMB<br>优惠券</span>
                </p>
                <span>满{{coupon.condition2}}元使用</span>
            </li>
            <li>
                <p> 兑换面值{{coupon.money2}}元优惠券</p>
                <span>满{{coupon.integral}}积分</span>
            </li>
            <li>
                <span @click="exchange(coupon.id)">立即兑换</span>
            </li>
        </ul>
        
    </div>
</template>

<script>
    import { Toast } from 'mint-ui';
    export default {
        name: "exchangeCoupon",
        inject: ['reload'],
        data: function () {
            return {
                couponsInfo:"",                           //可兑换的优惠卷列表
            }
        },
        methods: {
            // 获取可兑换的优惠卷
            getCreditsListInfo: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/user/convertCoupon",
                    dataType:"json",
                    data:{
                        
                    }
                })
                .then( res => {
                    // console.log(res);
                    if(res.data.status == 1){
                        this.couponsInfo = res.data.result.coupons;
                        console.log(this.couponsInfo);
                    }else{
                        Toast(res.data.msg);
                    }
                })
                .catch( err => {
                    Toast("系统错误,请稍后再试!");
                    console.log(err);
                })
            },
            exchange: function (id) {
                let that = this;
                layer.open({
                    content: '您确定要兑换？',
                    btn: ["确定","取消"],
                    yes: function (index) {
                        that.$http({
                            xhrFields: {
                                withCredentials: true
                            },
                            crossDomain: true,
                            method: "post",
                            url: that.weburl + that.hurl + "/user/convertCoupon",
                            dataType:"json",
                            data:{
                                coupon_id:id,
                                act: "convert"
                            }
                        })
                        .then( res => {
                            console.log(res);
                            if(res.data.status == 1){
                                Toast(res.data.msg);
                                setTimeout(() => {
                                    that.reload();
                                }, 1500);
                            }else{
                                Toast(res.data.msg);
                            }
                        })
                        .catch( err => {
                            Toast("系统错误,请稍后再试!");
                            console.log(err);
                        })
                        layer.close(index);
                    }
                })
            }
        },
        created: function () {
            this.getCreditsListInfo();
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
            hurl: function () {
                return this.$store.state.hurl;
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';

    .exchangeCoupon {
        width: 90%;
        margin: auto;
        ul {
            width: 100%;
            height: 65px;
            margin-bottom: 10px;
            li {
                float: left;
                .box-sizing;
                height: 65px;
                text-align: center;
                &:first-child {
                    width: 36%;
                    background: url(../../assets/images/personalCenter/discount_3.png) no-repeat;
                    background-size: 120px auto;
                    color: @font-primary;
                    p{
                        height: 65%;
                        span{
                            float: left;
                            &:first-child {
                                width: 40%;
                                font-size: @font * 2;
                            }
                            &:last-child {
                                font-size:@font ;
                            }
                        }
                    }
                    & > span {
                        padding:0  10px ;
                        font-size:.6rem;
                        .border-radius(20px);
                        background-color: #fe7096 ;


                    }
                }
                &:nth-child(2){
                    width: 40%;
                    font-size: .8rem;
                    padding: 17px  0;
                    span {
                        color: @brick_red;
                    }

                }
                &:nth-child(3){
                    width: 24%;
                    padding: 7px 0;
                    span{
                        .btn;
                        .img;
                        font-size: .9rem!important;
                        display: block;

                    }




                }
            }
        }
    }

</style>
